import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styles from '../ProductForm.module.scss';

const ProductFormLabels = ({ showNotes }) => {
  const { t } = useTranslation();
  const showNotesLabels = [
    t('ASSET_ID_ESN'),
    t('CAT_ORDER_LINE_ITEM_NO'),
    t('CAT_ORDER_CPART_NUMBER'),
    t('CAT_ORDER_CUST_ITEM_NO')
  ];
  const baseClasses = 'mb-1 text-univers--bold u-color--DarkGray';
  return (
    <div className="d-flex mb-1 border-bottom u-fs--14">
      <p className={cx(baseClasses, 'me-1 ')} style={{ width: 64 }}>
        {t('QUANTITY1')}*
      </p>
      <p
        className={cx(
          baseClasses,

          styles['product__form-column'],
          {
            'me-1': showNotes
          }
        )}
      >
        {t('ITEM_NUMBER')}*
      </p>
      {showNotes &&
        showNotesLabels.map((text, i) => (
          <p
            key={text}
            className={cx(baseClasses, styles['product__form-column'], {
              'me-1': i !== 3
            })}
          >
            {text}
          </p>
        ))}
      <div style={{ width: 32 }} />
    </div>
  );
};

ProductFormLabels.propTypes = {
  showNotes: PropTypes.bool
};

export default ProductFormLabels;
